import { RefObject, useEffect, useState } from "react";

/**
 * Height cap for sticky-mode tables: the viewport height minus the table's top offset minus a
 * 40px allowance for the fixed pagination footer. Recomputed on window resize. Extracted from
 * Table.tsx (file-length ratchet).
 */
export const useStickyMaxHeight = (
	outerRef: RefObject<HTMLDivElement | null>,
	sticky: boolean
): string | undefined => {
	const [stickyMaxHeight, setStickyMaxHeight] = useState<string | undefined>(undefined);

	useEffect(() => {
		if (!sticky) {
			return;
		}

		const calculateHeight = () => {
			if (outerRef.current) {
				const rect = outerRef.current.getBoundingClientRect();

				setStickyMaxHeight(`calc(100vh - ${Math.round(rect.top)}px - 40px)`);
			}
		};

		calculateHeight();

		window.addEventListener("resize", calculateHeight);

		return () => window.removeEventListener("resize", calculateHeight);
	}, [sticky, outerRef]);

	return stickyMaxHeight;
};
